import React from 'react';
import { Reveal } from './Reveal';
const FOUNDER_IMG = 'https://cdn.magicpatterns.com/uploads/spg1WtAjxcbmw9aGTYu273/professionalphoto.jpg';
export function About() {
  return <section id="about" className="w-full bg-cream py-24 lg:py-32" data-id="element-11" data-mp="2ttbzg70eiopg">
      <div className="mx-auto grid max-w-container items-center gap-14 px-6 lg:grid-cols-[0.85fr_1.15fr] lg:px-8" data-id="element-12" data-mp="2tv6gha8jxwo9">
        <Reveal data-id="element-13" data-mp="33r9j0h7bfxbq">
          <div className="relative overflow-hidden rounded-2xl border border-ink-950/10" data-id="element-14" data-mp="33rrqyb3cbzzh">
            <img src={FOUNDER_IMG} alt="Henry B. Dotson, Founder & CEO of MAEDSO" className="aspect-[4/5] w-full object-cover object-center" data-id="element-15" data-mp="38q300jlta6gn" />
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-16" data-mp="3hhldunvaca6k">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-600" data-id="element-17" data-mp="3hhv84nnd53i2">
            Who we are
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-ink-950 lg:text-5xl" data-id="element-18" data-mp="3rgkp8e7fqjx9">
            Built by educators who learned to sell.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-900/70" data-id="element-19" data-mp="2gs4b4feo5nrt">
            MAEDSO — Maximizing Education Solutions — exists to help the people
            improving education build businesses strong enough to sustain their
            mission. We pair deep sector experience with proven growth systems.
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-ink-900/70" data-id="element-20" data-mp="34i8csh8ardg6">
            We partner with founders and CEOs who share our passion for transforming
            the education sector — expanding their client base, revenue, and profits,
            and ultimately increasing both their impact and their business valuation.
          </p>

          <div className="mt-8 border-l-2 border-gold-500 pl-6" data-id="element-21" data-mp="2qq1yz1sm9ijw">
            <p className="font-display text-lg font-medium leading-relaxed text-ink-950" data-id="element-22" data-mp="3o6r87gjwbn3b">
              “We build the foundation for scalable success — so you can focus on the
              work that only you can do.”
            </p>
            <div className="mt-3 text-sm font-semibold text-ink-900" data-id="element-23" data-mp="66ltxucn6g7s">
              Henry B. Dotson
              <span className="font-normal text-ink-900/60" data-id="element-24" data-mp="b45d98o75j6l"> · Founder &amp; CEO</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}